module.exports = __webpack_public_path__ + "img/hold.8e49e938.png";